// ENG-1068: box-select multiple nodes the Unreal / Blender way. Left-drag on
// empty canvas rubber-bands a selection (both DCCs do this: Blender's node
// keymap binds select_box to select_mouse CLICK_DRAG with tweak; Unreal's
// SNodePanel starts a marquee on an empty-canvas left-drag). Dragging a node
// still moves it; panning is the middle mouse button; Shift extends the
// selection.
//
// Interaction model, Blender-style:
//   • left-drag on empty canvas → box select
//   • drag a node               → move it
//   • MOUSE WHEEL               → zoom in / out (Blender's convention)
//   • middle-drag OR Space+left-drag OR right-drag → pan
//   • right-click (no movement) → menu
// Wheel zooms (zoomOnScroll stays React Flow's default true — we just don't
// turn it into pan). Panning is middle-drag or Space+drag: on a Mac trackpad
// with no middle button, hold Space and drag one finger. Right-drag pans too,
// but NOT through React Flow's panOnDrag: given button 2, the browser's
// `contextmenu` stole the pointer from d3-zoom and the pan stuck to the
// cursor. RightDragPan (a child of each <ReactFlow>) pans on the right button
// itself and turns a right press back into a menu only when it did not move.
//
// Spread onto every <ReactFlow> graph editor so they can't drift apart. Kept as
// a bare prop bag (no @xyflow import) — `selectionMode: 'partial'` is exactly
// SelectionMode.Partial's value, so it needs no enum.
export const GRAPH_MULTISELECT_PROPS = {
  selectionOnDrag: true,          // left-drag on the pane = box select
  panOnDrag: [1],                 // pan with the middle button (Space+drag also pans)
  selectionMode: 'partial',       // select nodes the box merely touches (DCC behaviour)
  multiSelectionKeyCode: 'Shift', // Shift-click / Shift-box extends the selection
  selectionKeyCode: null,         // no dedicated key — left-drag always selects
  // React Flow stops zooming out at 0.5, which cannot fit a large graph on
  // screen. 0.05 shows the whole conversational event graph in one view.
  minZoom: 0.05,
}
